import { BLOCK_OPENAPI, type BlockOpenAPIData } from '@gitbook/doc-core';
import type { Block } from '@gitbook/slate';

import { createCustomBlock } from './compiler-custom-blocks';
import type { GastToMdastTransformMap } from './types';

/**
 * Convert a swagger block into Markdown nodes.
 */
export const transformSwaggerBlocks: GastToMdastTransformMap<Block> = {
    [BLOCK_OPENAPI]: async (node: Block, _eat, options) => {
        const data = node.data.toObject<BlockOpenAPIData>();

        const resolved = await options.resolveContentRef(data.ref);
        if (!resolved) {
            return [];
        }

        return [
            createCustomBlock(
                'openapi',
                {
                    src: resolved.url,
                    path: data.path,
                    method: data.method,
                    ...(typeof data.expanded !== 'undefined'
                        ? { expanded: `${Boolean(data.expanded)}` }
                        : undefined),
                    ...(typeof data.fullWidth !== 'undefined'
                        ? { fullWidth: `${Boolean(data.fullWidth)}` }
                        : undefined),
                },
                [
                    {
                        type: 'link',
                        title: undefined,
                        url: resolved.url,
                        children: [
                            {
                                type: 'text',
                                value: resolved.text,
                            },
                        ],
                    },
                ]
            ),
        ];
    },
};
